import React from 'react'

import {
    getCurrentUser,
    getCurrentAccount,
} from 'state/selectors'

import { connect } from 'react-redux'
import ProfilePicture from 'components/profile/profile-picture'

import ChatTitle from 'components/chat/title'

import BigChatStatus from './big-chat-status'
import BigChatFiles from './big-chat-files'

const BigChatAside = ({
    currentChatId,
    allChats,
    allUsers,
    userData,
    noop
}) => {
    const chatObject = allChats[currentChatId]

    if (!chatObject) {
        return null
    }

    const chatUsers = chatObject.userIds.map(userId => {
        return allUsers[userId]
    }).filter(Boolean)

    const subtitle = (() => {
        const nonMeUsers = chatUsers.filter(user => user.id !== userData.id)

        if(!nonMeUsers.length){
            return `Just you.`
        }

        if (chatUsers.length === 2) {
            return `Just you and ${nonMeUsers[0].first_name}.`
        }

        let response = 'You, '

        nonMeUsers.forEach((user, index) => {
            const isLast = index === nonMeUsers.length - 1

            if(isLast){
                response += ` and `
            }

            response += `${user.first_name}`

            if(!isLast){
                response += `, `
            }
        })

        return response+'.'
    })()

    return (
        <aside>
            <BigChatStatus userData={userData} />
            <ProfilePicture
                users={chatUsers}
                userData={userData}
            />
            <div className='chat-title'>
                <ChatTitle
                    chat={chatObject}
                    handleChatNameChange={noop}
                    saveChatTitle={noop}
                    optimistic={false}
                    userId={userData.id}
                    isNameBeingEdited={false}
                    isBigChat
                />
            </div>
            <span>
                { subtitle }
            </span>
            <BigChatFiles
                chat={chatObject}
            />
        </aside>
    )
}

const mapStateToProps = state => {
    return {
        userData: getCurrentUser(state, true),
        accountData: getCurrentAccount(state),
        allChats: state.account.entities.chats,
        allUsers: state.account.entities.users,
        allVersions: state.account.entities.versions
    }
}

export default connect(mapStateToProps, {})(BigChatAside)